import React, { useContext, useMemo, useRef } from 'react'
import { observer } from 'mobx-react-lite';
import CampaignInfluenerSidebarHeader from './CampaignInfluencerSidebarParts/CampaignInfluencerSidebarHeader';
import CampaignInfluencerSidebarPage from './CampaignInfluencerSidebarParts/CampaignInfluencerSidebarPage';
import CampaignInfluencerSidebarNav from './CampaignInfluencerSidebarParts/CampaignInfluencerSidebarNav';
import { useParams } from 'react-router-dom';
import CampaignAuthentication from '../../../../../models/CampaignAuthentication';
import { SharedCampaignContext } from '../../../../../contexts/Advertiser/SharedCampaignContext';
import CampaignInfluencerSidebarShell from '../../../../Shared/CampaignInfluencerSidebar/CampaignInfluencerSidebarShell';


export default observer(function CampaignInfluencerSidebar(){
  const { authentications } = useContext(SharedCampaignContext)
  const { campaign_authentication_id } = useParams()
  const fallbackAuthRef = useRef(null)
  if (fallbackAuthRef.current === null) {
    fallbackAuthRef.current = new CampaignAuthentication()
  }

  const auth = useMemo(
    () => authentications.find(authentication => +authentication.campaign_authentication_id === +campaign_authentication_id) ?? fallbackAuthRef.current,
    [campaign_authentication_id, authentications]
  )

  return (
    <CampaignInfluencerSidebarShell
      auth={auth}
      HeaderComponent={CampaignInfluenerSidebarHeader}
      NavComponent={CampaignInfluencerSidebarNav}
      PageComponent={CampaignInfluencerSidebarPage}
      className='bg-white dark:bg-rb-dark-mode'
    />
   );
})
